import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import {
    Box,
    Button,
    Container,
    Paper,
    Typography,
    CircularProgress
} from '@mui/material';

export default function LoginPage() {
    const { isAuthenticated, isLoading, signinRedirect } = useAuth();
    const navigate = useNavigate();
    const location = useLocation() as any;
    const from = location.state?.from?.pathname || '/data';

    useEffect(() => {
        if (isAuthenticated) {
            navigate(from, { replace: true });
        }
    }, [isAuthenticated, navigate, from]);

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container maxWidth="xs">
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', transform: 'translateY(-8%)' }}>
                <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
                    <Typography variant="h5" component="h1" gutterBottom>Anavela Login</Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                        Please sign in using the identity provider.
                    </Typography>
                    <Button 
                        variant="contained" 
                        fullWidth 
                        size="large"
                        onClick={() => signinRedirect()}
                    >
                        Sign In
                    </Button>
                </Paper>
            </Box>
        </Container>
    );
}